import React, { useId } from "react";
import { CheckCircle2, Clock3, ShieldAlert } from "lucide-react";

import PatternSections, { ScreenIntro, Section } from "../PatternSections";
import { RESULT } from "./editorModel";
import { TEXT } from "./editorText";

const P = TEXT.previewScreen;

/** What would be learned, as a read-only summary, plus what was left out as too short. */
export function PreviewScreen({ state, blocked }) {
  const id = useId();
  const { draft, dropped } = state.preview;
  return (
    <section className="le-screen" aria-labelledby={`${id}-h`}>
      <ScreenIntro id={`${id}-h`} heading={P.heading} meta={P.hint} />
      {blocked && (
        <p className={`le-note ${blocked === "recording" ? "le-note--waiting" : "le-note--blocked"}`}
          role={blocked === "recording" ? "status" : "alert"} aria-live="polite">
          {TEXT.eligibility[blocked] || TEXT.eligibility.fallback}
        </p>
      )}
      {!blocked && <p className="le-note">{P.note}</p>}

      <PatternSections labels={P} category={state.category.label} symptoms={draft.symptoms} steps={draft.steps}
        rootCause={draft.rootCause} fixKindLabel={TEXT.fixKinds[draft.fixKind]} fixText={draft.fixText}>
        {dropped.length > 0 && (
          <Section label={P.dropped} className="le-dropped">
            <ul className="le-list">
              {dropped.map((d, i) => <li key={`${d.section}-${i}`} className="le-muted">{`${d.text} (${d.section}: ${d.reason})`}</li>)}
            </ul>
          </Section>
        )}
      </PatternSections>
    </section>
  );
}

/** Learned, sent for review, or refused: the outcome, with its reason. */
export function ResultScreen({ result }) {
  const text = TEXT.result[result.kind];
  if (result.kind === RESULT.REFUSED || !text) {
    return (
      <section className="le-result le-result--refused" role="alert">
        <ShieldAlert size={22} aria-hidden="true" />
        <h3 className="le-h">{TEXT.refused.heading}</h3>
        <p>{TEXT.refused[result.reason] || TEXT.refused.fallback}</p>
      </section>
    );
  }
  const Icon = result.kind === RESULT.LEARNED ? CheckCircle2 : Clock3;
  return (
    <section className="le-result" role="status" aria-live="polite">
      <Icon size={22} aria-hidden="true" />
      <h3 className="le-h">{text.heading}</h3>
      <p>{text.body}</p>
    </section>
  );
}
